function DailyMtdYtd() {
    return (
      <>
        <div className="font-bold text-lg mb-16">DailyMtdYtd</div>
      </>
    );
  }
  
  export default DailyMtdYtd;